import { AppIntegrationsRepository, DevicesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$timeout', '$scope', '$state', '$window'];

class BreadcrumbController {

    constructor($timeout, $scope, $state, $window) {

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope.deviceRepo = DevicesRepository;
        this.$scope.appIntegrationsRepo = AppIntegrationsRepository;
        this.$scope.isDropdownOpen = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

    }

    /*  Open dropdown and creates a listener which is watching every click.
    The listener is destroyed after one click. */

    openDropdown(event) {

        this.$scope.isDropdownOpen = !this.$scope.isDropdownOpen;
        const bodyElement = angular.element(this.$window.document);

        if (this.$scope.isDropdownOpen) {

            bodyElement.on('click', () => {

                this.$timeout(() => {

                    this.$scope.isDropdownOpen = false;

                }, 0);

                bodyElement.off('click');

            });

        }
        event.stopPropagation();

    }

    addNewMobileDevice(os) {

        const appId = CWCONFIG.defaultDeployedAppId[os];

        Mixpanel.send('ConnectWeb Add New Device Click', { Page: 'Antitheft Service', 'Device OS': os });
        this.$state
            .go('root.dashboard.devices.ltb.deploy', {
                ltb: 'deploy',
                appId,
                resourceId: 'new',
            });

    }

}


class BreadcrumbDirective {

    constructor() {

        this.template = require('./breadcrumb.html');
        this.restrict = 'E';
        this.replace = false;
        this.scope = {
            app: '=',
            devices: '=',
            showDeployMobile: '@',
            selectedDevice: '=',
            selectCallback: '&',
        };

        _controllerDependencies.push(($timeout, $scope, $state, $window) =>
            new BreadcrumbController($timeout, $scope, $state, $window));

        this.controller = _controllerDependencies;
        this.controllerAs = 'breadcrumbCtrl';

    }

}

_directiveDependencies.push(() => new BreadcrumbDirective());


angular.module('directives')
    .directive('breadcrumb', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/breadcrumb/breadcrumb.js